/* eslint-disable no-prototype-builtins */
export const middlewareMySchedule = (data: string[]): IGroupedTimeSlots => {
  const groupedTimeSlots: IGroupedTimeSlots = {};

  data.forEach((timeSlot: string) => {
    const date = timeSlot.split(' ');

    if (!groupedTimeSlots.hasOwnProperty(date[0])) {
      groupedTimeSlots[date[0]] = [];
    }

    groupedTimeSlots[date[0]].push(date[1]);
  });

  return groupedTimeSlots;
};
